// Engineering as a Service (squads) service page.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function EngineeringSquads() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.serviceA}
        eyebrow="Services · Squads"
        headline="Senior engineers, ready to"
        italicWord="ship."
        lede="We embed senior AI engineers with your team so you can move at the speed your business needs."
      />

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Senior squads, not body shops.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Every engineer we embed has real production experience. Not graduates being trained on your
              project. Not offshore resources managed remotely. Senior engineers who have shipped AI
              systems in demanding environments.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We work alongside your existing team, transfer knowledge as we go and leave you with
              capability you own.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Embedded from week one.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We match engineers to your tech stack, your sector and your delivery timeline. Typically a
              squad is one to three engineers embedded for a fixed engagement period of eight to
              twenty-four weeks.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We use your tools, your processes and your repository. At the end of the engagement your
              team can maintain and extend everything we built.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You need to move faster without growing headcount.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have a delivery deadline and not enough senior AI engineers on your team. You want to
              build internal capability, not create a permanent dependency on an external vendor.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You are in mining, defence, construction or industrial technology and you need engineers
              who understand your domain, not just the AI tooling.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
